export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";